import { Link } from '@chakra-ui/react';

// Matches http/https URLs embedded in a block of text.
const URL_REGEX = /(https?:\/\/[^\s]+)/g;

// Trailing punctuation that should not be treated as part of the URL
// (e.g. a full stop at the end of a sentence).
const TRAILING_PUNCTUATION = /[.,;:!?)\]}'"]+$/;

/**
 * Renders a string with any embedded http(s) URLs turned into clickable
 * hyperlinks that open in a new tab. Returns inline content, so it is meant to
 * be placed inside an existing text container (e.g. a Chakra `<Text>`).
 *
 * @param {{ text?: string }} props
 */
export default function LinkifiedText({ text }) {
    if (typeof text !== 'string' || text.length === 0) {
        return text ?? null;
    }

    return text.split(URL_REGEX).map((segment, index) => {
        if (!/^https?:\/\//.test(segment)) {
            return segment;
        }

        const trailing = (segment.match(TRAILING_PUNCTUATION) || [''])[0];
        const url = trailing ? segment.slice(0, -trailing.length) : segment;

        return (
            <span key={index}>
                <Link
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    color="messenger.500"
                    textDecoration="underline"
                    wordBreak="break-all"
                    onClick={(e) => e.stopPropagation()}>
                    {url}
                </Link>
                {trailing}
            </span>
        );
    });
}
